import { getGamInventoryType, inventoryTypes } from '../helpers'

import { AD_INVENTORY } from '../../../../../Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/fields'

export const isAdInventoryTargetingEnabled = right => {
  return right.advanced_settings?.ad_inventory_targeting_enabled === true
}

export const formatInventoryTargeting = ({ inventory, right }) => {
  const inventoryType = getGamInventoryType(right[AD_INVENTORY])

  return {
    ...(inventoryType === inventoryTypes.placements && {
      targeted_placement_ids: inventory.map(placement => placement.placement_id)
    }),

    ...(inventoryType === inventoryTypes.ad_units && {
      targeted_ad_units: inventory.map(adUnit => ({
        ad_unit_id: adUnit.ad_unit_id
      }))
    })
  }
}
